<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" (ngSubmit)="save()">
    <modal-header [plugin]="plugin" [menuModal]="menuModal" [menuComponent]="menuComponent"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-stabilizer">
        <div class="ir-content--modal th-content th-plugin-photo">
          <div class="ir-plugin-photo--fixed maintenance-plugin">
            <div
              class="ir-btn th-btn-normal photo-edit"
              *ngIf="!inspection.isOffline"
              style="right: 24em"
              (click)="download()"
            >
              <i class="material-icons">save_alt</i>
            </div>
            <div class="ir-btn th-btn-normal left photo-edit" (click)="openEditImage()">
              <i class="material-icons">crop_rotate</i>
            </div>
            <div class="ir-btn th-btn-normal photo-edit" (click)="openAnnotateImage()">
              <i class="material-icons">draw</i>
            </div>
            <div class="ir-stabilizer maintenance-plugin">
              <div [innerHtml]="svgElement" *ngIf="svg" class="edit-svg"></div>
              <img *ngIf="assetUrl && !svg" class="edit-image" [src]="assetUrl" alt="" />
            </div>
          </div>
          <div class="ir-row">
            <div
              class="ir-cell-tin-push6 ir-cell-sma-push6 ir-cell-mid-push6 ir-cell-lar-push6 ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6"
            >
              <div class="ir-plugin-modal--photonote">
                <h2>
                  <span>{{ 'plugins.note.can-add-note' | translate }}</span>
                </h2>
                <div class="ir-form-group margin">
                  <textarea
                    name="comment"
                    rows="6"
                    placeholder="Your comment"
                    [(ngModel)]="comment"
                    class="ir-form-set"
                  ></textarea>
                </div>
                <table class="ir-plugin-table" style="margin-bottom: 10px">
                  <tr>
                    <td class="margin-big">
                      <h2>
                        <span>{{ 'plugins.add-photos.to' | translate }}</span>
                      </h2>
                    </td>
                    <td class="margin-big" style="width: 75%">
                      <div class="ir-form-group">
                        <input type="hidden" class="ir-form-set" />
                        <div class="ir-line ir-select th-select" (click)="openTypesSelector(type)">
                          <div class="ir-line--right">
                            <div class="ir-btn th-btn-modal--content">
                              <i class="material-icons">arrow_drop_down</i>
                            </div>
                          </div>
                          <div class="ir-line-content">
                            <span>{{
                              (type || type === 0) && type !== -1
                                ? (type | fileToType)
                                : ('plugins.add-photos.select-comment-type' | translate)
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="th-plugin-line--checkbox label">
                    <td class="margin-big"></td>
                    <td>
                      <div (click)="changeCheckboxValue()">
                        <i class="material-icons" *ngIf="!fullWidth">check_box_outline_blank</i>
                        <i class="material-icons important" *ngIf="fullWidth">check_box</i>
                        <span>{{ 'plugins.add-photos.full-width' | translate }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>
                        <strong>{{ 'plugins.add-photos.annotation-id' | translate }}</strong>
                      </span>
                    </td>
                    <td>
                      <span>
                        <strong>{{ 'plugins.add-photos.annotation-description' | translate }}</strong>
                      </span>
                    </td>
                  </tr>
                  <tr *ngFor="let annotationComment of annotationComments | keyvalue">
                    <td *ngIf="annotationComment?.key">
                      <span>{{ annotationComment.key }}</span>
                    </td>
                    <td *ngIf="annotationComment?.value">
                      <span>{{ annotationComment.value }}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="updateImage($event)" #imageEditModal></modal>
<modal (modalOutput)="updateImageAnnotation($event)" #imageAnnotationModal></modal>
<modal (modalOutput)="selectTypesMenu($event)" #typesModal></modal>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deleteFile($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.add-photos.sure-to-delete' | translate"
  [danger]="true"
></confirm>
